import { render, staticRenderFns } from "./QuestionFinish.vue?vue&type=template&id=03a1a730&"
import script from "./QuestionFinish.vue?vue&type=script&lang=js&"
export * from "./QuestionFinish.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFinish.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports